<div class="form-group row">
  <label class="control-label col-4">{{'Ngày tạo' | translate}}<span class="cred">(*)</span></label>
  <div class="col-8">
    <kendo-dateinput tabindex="1" style="width:100%;" [format]="'dd/MM/yyyy'" [(value)]="doituongSelect.Created"></kendo-dateinput>
  </div>
</div>

<div class="row form-group">
  <label class="control-label col-4 ng-binding">{{'Người tạo' | translate}}</label>
  <div class="col-8">
    <input type="text" tabIndex="2" class="form-control" placeholder="" disabled="disabled" [(ngModel)]="doituongSelect.CreatedBy">
  </div>
</div>




<div class="row form-group">
  <label class="control-label col-4 ng-binding">{{'Số buổi' | translate}}</label>
  <div class="col-8">
    <input class="form-control"
           maxlength="20"
           tabindex="13"
           currencyMask
           [(ngModel)]="doituongSelect.SoBuoi"
           name="value"
           [placeholder]="''"
           [options]="ngxCurrencyOptions" autocomplete="off" />
  </div>
</div>





<div class="row form-group">
  <label class="control-label col-4">{{'Ghi chú' | translate}}</label>
  <div class="col-8 required-field">
    <textarea type="text" tabindex="6" class="form-control" rows="3" [(ngModel)]="doituongSelect.GhiChu"></textarea>
  </div>
</div>





<div class="row form-group">

</div>

<div class="modal-footer" style="display: flex;justify-content: space-between;">
  <div style="display:flex;">
    <!--<div class="checkbox c-checkbox"> password
      <label>
        <input tabIndex="20" type="checkbox" [(ngModel)]="doituongSelect.TrangThaiXuLy" />
        <span class="fa fa-check"></span> Đã xử lý xong
      </label>
    </div>-->
  </div>
  <div class="">
    <button class="mb-1 mr-1 btn btn-secondary" (click)="closeModal()" title="Ấn ESC để thoát" style="padding-top:0px !important">Hủy bỏ</button>
    <button type="submit" *ngIf="doituongSelect.Id!==null" (click)="XoaChotBuoiHoc()" title="Ấn F9 để lưu" class="mb-1 mr-1 btn btn-danger" style="padding-top:0px !important">Xóa chốt buổi học</button>
    <button type="submit" (click)="ThucHien()" title="Ấn F9 để lưu" class="mb-1 mr-1 btn btn-primary" style="padding-top:0px !important">Lưu lại chốt buổi học</button>
  </div>

</div>


